export default function TransactionsApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getTransactions(bankFileId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/BankTransactions?FileId=${bankFileId}`));
        });
    }

    function updateTransaction(transaction) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/BankTransaction/update`, transaction));
        });
    }

    function getTransactionHistory(from, to, maxResults = 0) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/BankTransactions/History?DateFrom=${from}&DateTo=${to}&MaxResults=${maxResults}`));
        });
    }

    function getIgnoreReasons() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/BankTransactions/IgnoreReasons`));
        });
    }

    function ignoreTransaction(transactionId, reasonId) {
        const ignoreReason = {
            bankTransactionId: transactionId,
            ignoreReasonId: reasonId
        }
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/BankTransactions/IgnoreReason`, ignoreReason));
        });
    }

    function updateExportType(transactionId, fileTypeId) {
            return buildRequest().then(function (req) {
                return makeRequest(req.put(`${baseUrl}/banktransaction/exporttype?bankTransactionId=${transactionId}&fileTypeId=${fileTypeId}`));
            });
    }

    function updateTransactionMcot(transaction) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/banktransaction/updatemcot`, transaction));
        });
    }

    function createTransaction(transactionData) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/banktransaction/create`, transactionData));
        });
    }

    function deleteTransaction(transactionId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/banktransaction?BankTransactionId=${transactionId}`));
        });
    }

    function getIgnoredTransactions(ignoreCode = '') {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/banktransactions/ignoreReason?ignoreCode=${ignoreCode}`));
        });
    }

    function upsertCentreTransaction(transactionData) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/centretransaction/upsert`, transactionData));
        });
    }

    function getCentreTransactions(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/centretransactions?centreId=${centreId}`));
        });
    }
    
    function deleteCentreTransaction(transactionId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/CentreTransaction?transactionId=${transactionId}`));
        });
    }

    function updateFlag(flag) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/banktransactions/updateflag`, flag));
        });
    }

    function getTransactionsByChild(childId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/BankTransactions/historyByChild?ChildId=${childId}`));
        });
    }

    function getTransactionTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/BankTransactions/TransactionTypes`));
        });
    }

    return {
        getTransactions,
        updateTransaction,
        getTransactionHistory,
        getIgnoreReasons,
        ignoreTransaction,
        updateExportType,
        updateTransactionMcot,
        createTransaction,
        deleteTransaction,
        getIgnoredTransactions,
        upsertCentreTransaction,
        getCentreTransactions,
        deleteCentreTransaction,
        updateFlag,
        getTransactionsByChild,
        getTransactionTypes
    }

}